import React from 'react';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';
import useTranslation from './useTranslation';
import Icon from './Icon';
import { getOptimizedPoiImage } from '../utils/imageUtils';

const PoiCardLite = ({ 
  poi, 
  taxonomyData, 
  distance,
  onClose,
  showCloseButton = true // default a true per mantenere compatibilità
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="card border shadow-sm position-relative align-items-start p-0" 
         style={{ 
           borderRadius: '16px',
           overflow: 'hidden'
         }}>
      {showCloseButton && (    
        <button
        onClick={onClose}
        className="btn bg-white close-button position-absolute top-0 end-0 z-1 opacity-75 border rounded-circle shadow-sm p-1 m-1 d-flex align-items-center justify-content-center"
        aria-label="{t('chiudi')}"
        style={{ width: '32px', height: '32px' }}
      >
        <Icon name="close" />
      </button>
       )}
      {/* Immagine */}
      <div style={{ height: '50%', width: '100%' }}>
        <img
          src={getOptimizedPoiImage(poi, 'max_650x650')}
          className="w-100 h-100"
          alt={poi.field_immagini?.[0]?.alt || poi.title}
          style={{
            display: 'block',
            objectFit: 'cover'
          }}
        />
      </div>

      {/* Contenuto testuale */}
      <div className="py-2 px-3 text-start" style={{width: '100%'}}>
        {/* Categoria con icona */}
        <div className="d-flex justify-content-start mb-1">
          {taxonomyData[poi.field_tipologia_poi?.[0]?.target_id]?.icon && (
            <img 
              src={taxonomyData[poi.field_tipologia_poi[0].target_id].icon}
              alt={taxonomyData[poi.field_tipologia_poi[0].target_id].title}
              style={{ width: '20px', height: '20px' }}
              className="me-1"
            />
          )}
          <span className="small text-muted">
            {taxonomyData[poi.field_tipologia_poi?.[0]?.target_id]?.title || t('puntoInteresse')}
          </span>
        </div>

        {/* Titolo */}
        <h5 className="card-title fw-bold text-start text-truncate mt-2 mb-2">
          {poi.title[0].value}
        </h5>

        {/* Indirizzo */}
        {poi.field_indirizzo && (
          <p className="mb-0 text-muted text-truncate" style={{ fontSize: '0.875rem' }}>
            <Icon name="location_on" className="align-bottom me-1" style={{ fontSize: '1rem' }} />
            {poi.field_indirizzo[0]?.value}
          </p>
        )}

        {/* Distanza e bottone */}
        <div className="d-flex justify-content-between align-items-center mt-1">
          <p className="mb-0" style={{ fontSize: '0.875rem' }}>
            <Icon name="near_me" className="align-bottom me-1" style={{ fontSize: '1rem' }} />
            {t('distanza')} <span className="fw-bold">{distance}</span>
          </p>
          <button 
            onClick={() => navigate(`/poi/${poi.nid[0].value}`)}
            className="btn btn-white border rounded-pill py-1 px-3 d-flex align-items-center shadow-sm"
            style={{ fontSize: '0.875rem' }}
          >
           {t('vaiAllaScheda')}
          </button>
                  </div>
      </div>
    </div>
  );
};

export default PoiCardLite;